export const routesTanitim = [
  {
    path: "/ogrenci",
    name: "ogrenci",
    component: () => import("@/views/ogrenci/index.vue"),
    meta: {
      public: false,
      title: "Öğrenci",
      yetki: { k: [1019102] },
    },
  },
  {
    path: "/varsayilan_fiyat",
    name: "varsayilan_fiyat",
    component: () => import("@/views/tanitim/varsayilan_fiyat/index.vue"),
    meta: {
      public: false,
      title: "Varsayilan Fiyat",
      yetki: { k: [1017008] },
    },
  },
  {
    path: "/ogrenci/:uuid",
    name: "ogrenci_detay",
    component: () => import("@/views/ogrenci/profil/index.vue"),
    meta: {
      public: false,
      title: "Öğrenci Detay",
      yetki: { k: [1019104] },
    },
  },

  {
    path: "/sube_tanitim",
    name: "sube_tanitim",
    component: () => import("@/views/tanitim/sube/index.vue"),
    meta: {
      public: false,
      title: "Şube",
      yetki: { k: [1020002] },
    },
  },
  {
    path: "/spordali_tanitim",
    name: "spordali_tanitim",
    component: () => import("@/views/tanitim/spordali/index.vue"),
    meta: {
      public: false,
      title: "Spor Dalı",
      yetki: { k: [1020102] },
    },
  },
  {
    path: "/egitimturu_tanitim",
    name: "egitimturu_tanitim",
    component: () => import("@/views/tanitim/egitim_turu/index.vue"),
    meta: {
      public: false,
      title: "Eğitim Türü",
      yetki: { k: [1020602] },
    },
  },

  {
    path: "/etkinlik",
    name: "etkinlik",
    component: () => import("@/views/etkinlik/index.vue"),
    meta: {
      public: false,
      title: "Etkinlik",
      yetki: { k: [1010002] },
    },
  },
  {
    path: "/sinif_tanitim",
    name: "sinif_tanitim",
    component: () => import("@/views/sinif_tanitim/index.vue"),
    meta: {
      public: false,
      title: "Takım Tanıtım",
      yetki: { k: [1017002] },
    },
  },
  {
    path: "/sinif/:uuid",
    name: "sinif",
    component: () => import("@/views/sinif_tanitim/profil/index.vue"),
    meta: {
      public: false,
      title: "Takım Tanıtım",
      yetki: { k: [1017004] },
    },
  },
  {
    path: "/takimlar",
    name: "takimlar",
    component: () => import("@/views/sinif_egitmen/index.vue"),
    meta: {
      public: false,
      title: "Takımlar",
      yetki: { e: true },
    },
  },
  {
    path: "/takim/:uuid",
    name: "takim",
    component: () => import("@/views/sinif_egitmen/profil/index.vue"),
    meta: {
      public: false,
      title: "Takım",
      yetki: { e: true },
    },
  },
  {
    path: "/envanter",
    name: "envanter",
    component: () => import("@/views/envanter/index.vue"),
    meta: {
      public: false,
      title: "Envanter",
      yetki: { k: [1015002] },
    },
  },
  {
    path: "/envanter/:uuid",
    name: "envanter_detay",
    component: () => import("@/views/envanter/profil/index.vue"),
    meta: {
      public: false,
      title: "Envanter Detay",
      yetki: { k: [1015004] },
    },
  },
  {
    path: "/yoklama",
    name: "yoklama",
    component: () => import("@/views/yoklama/index.vue"),
    meta: {
      public: false,
      title: "Yoklama",
      yetki: { k: [1111002] },
    },
  },
 
];
